import { render, staticRenderFns } from "./color-filter.vue?vue&type=template&id=60e72d40&"
import script from "./color-filter.vue?vue&type=script&lang=js&"
export * from "./color-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e72d40')) {
      api.createRecord('60e72d40', component.options)
    } else {
      api.reload('60e72d40', component.options)
    }
    module.hot.accept("./color-filter.vue?vue&type=template&id=60e72d40&", function () {
      api.rerender('60e72d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/color-filter/color-filter.vue"
export default component.exports